import React from "react";
import { Box } from "@mui/material";

import { GraphInterval, GraphStyle } from "../../types/models/AssetSymbol";

import { AppState, useSelector } from "../../store/store";
import GraphIcon from "./GraphIcon";
import { useDispatch } from "../../hooks";
import { homeActions } from "../../store/slices/homeSlice";

const GraphIntervals: React.FC = () => {
  const dispatch = useDispatch();
  const { interval, graphStyle } = useSelector<AppState["home"]>(
    ({ home }) => home
  );
  const intervals: GraphInterval[] = [
    { value: "1", label: "1m" },
    { value: "3", label: "3m" },
    { value: "5", label: "5m" },
    { value: "15", label: "15m" },
    { value: "30", label: "30m" },
    { value: "60", label: "1h" },
    { value: "120", label: "2h" },
    { value: "180", label: "3h" },
    { value: "240", label: "4h" },
    { value: "D", label: "1d" },
  ];
  const graphqStyles: GraphStyle[] = ["1", "2", "3", "9"];

  const handleSetGraphStyle = (style: GraphStyle) =>
    dispatch(homeActions.setGraphStyle({ graphStyle: style }));

  const handleSetInterval = (d: GraphInterval) =>
    dispatch(homeActions.setInterval({ interval: d.value }));

  return (
    <div style={{ overflow: "hidden" }}>
      <Box
        sx={{
          color: "grey",
          display: "flex",
          justifyContent: "space-between",
          overflow: "hidden",
          mb: 1,
        }}
      >
        {graphqStyles.map((graph: GraphStyle) => {
          const isActive = graph === graphStyle;
          return (
            <div
              style={{
                padding: "2px 25px",
                margin: "5px",
                border: isActive ? "none" : "0.5px solid grey",
                borderRadius: "5px",
                backgroundColor: isActive ? "#373b4b" : "transparent",
              }}
              key={graph}
              onClick={() => handleSetGraphStyle(graph)}
            >
              <GraphIcon graph={graph} />
            </div>
          );
        })}
      </Box>
      <Box sx={{ color: "grey", display: "flex", overflow: "scroll" }}>
        {intervals.map((d: GraphInterval) => {
          const isActive = d.value === interval;
          return (
            <div
              style={{
                color: "white",
                padding: "2px 25px",
                margin: "5px",
                border: isActive ? "none" : "0.5px solid grey",
                backgroundColor: isActive ? "#373b4b" : "transparent",
                borderRadius: "5px",
              }}
              key={d.value}
              onClick={() => handleSetInterval(d)}
            >
              {d.label}
            </div>
          );
        })}
      </Box>
    </div>
  );
};

export default GraphIntervals;
